import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import schema from '../../../store/slices/schema';

import SchemaPreferencesPane from './SchemaPreferencesPane';

const connector = connect(null, { onPurgeCache: () => schema.purgeCache() });

export type SchemaPreferencesPaneContainerProps = ConnectedProps<
  typeof connector
>;

export default connector(SchemaPreferencesPane);
